/*
  Shoes Egy — search panel with live results.

  Any [data-search-open] link (the header magnifier, Search in the menu) opens
  the panel instead of going to /search; without this script it still goes to
  /search. Typing asks Shopify's predictive search for
  sections/shoes-egy-predictive-search.liquid after a short pause, and a newer
  keystroke cancels the request before it. Enter submits the plain search
  form, so the full results page is always one key away.
*/
(function () {
  var panel = document.getElementById('ShoesSearch');
  if (!panel || typeof panel.showModal !== 'function') return;
  var input = panel.querySelector('input[name=q]');
  var results = panel.querySelector('[data-ps-out]');
  var start = panel.querySelector('[data-ps-start]');
  var timer = null;
  var ctrl = null;
  var opener = null;

  function run() {
    var q = input.value.trim();
    if (ctrl) ctrl.abort();
    if (q.length < 2) {
      results.innerHTML = '';
      start.hidden = false;
      return;
    }
    ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var url = '/search/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6' +
      '&resources[options][fields]=title,vendor,product_type,tag,variants.title' +
      '&section_id=shoes-egy-predictive-search';
    panel.classList.add('is-loading');
    fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var out = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ps-results]');
        results.innerHTML = out ? out.innerHTML : '';
        start.hidden = !!out;
        panel.classList.remove('is-loading');
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') panel.classList.remove('is-loading'); });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(run, 180);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-search-open]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    opener = link;
    var menu = document.getElementById('ShoesMenu');
    if (menu && menu.open) menu.close();
    panel.showModal();
    document.documentElement.classList.add('shoes-search-open');
    input.focus();
    if (input.value.trim().length >= 2) run();
  });

  panel.querySelector('[data-ps-close]').addEventListener('click', function () { panel.close(); });
  panel.addEventListener('close', function () {
    document.documentElement.classList.remove('shoes-search-open');
    if (opener) opener.focus();
  });
  panel.addEventListener('click', function (e) {
    if (e.target !== panel) return;
    var r = panel.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) panel.close();
  });
})();
